import React from "react"




export const Contact = () => {
    return (
        <div>
            <div>location</div>
            <div>phone</div>
            <div>mail</div>
            <div>{`not an interesting page too lazy to create :)`}</div>
        </div>
    )
}